import React from 'react';
import styles from './Home.module.css';
import SVHeader from "../components/header/SVHeader";
import LandingPage from "../components/LandingPage/LandingPage";

function Home() {
    return (
        <div className={styles.container}>
            <SVHeader />
            <LandingPage />
        </div>
    );
}

export default Home;

